import React, {PropTypes} from 'react';


class RhinoCheckbox extends React.Component {

  render() {
    return (
      <div className='RhinoCheckbox'>
        <label className={'control control--checkbox'}>{this.props.label}
          <input 
            type='checkbox' 
            disabled={this.props.disabled} 
            checked={this.props.selected} 
            onChange={this.props.changeMethod.bind(this)} />
          <div className='control__indicator'></div>
        </label>
      </div>
    );
  }
}
export default RhinoCheckbox;